<template>
  <div class="sub-menu-help sub-menu">
    <p
      class="
        text-desktop-14-desktop
        text-mobile-12-mobile
        sub-menu-help__title
      "
      v-text="$string('product.sub_menu_content.help')"
    />

    <!-- Text content -->
    <div
      v-if="content?.help?.text"
      class="sub-menu-help__text"
    >
      <p
        class="
          text-desktop-14-desktop
          text-mobile-12-mobile
          sub-menu-help__text-content
        "
        v-text="content.help.text"
      />
    </div>

    <!-- Links content -->
    <div
      v-if="clickableListContent"
      class="sub-menu-help__links"
    >
      <clickable-list
        ref="helpLinks"
        display-icons
        :links="clickableListContent"
        @mouseleave="resetList"
      />
    </div>
  </div>
</template>

<script>

/**
 * Vue: Sub menu help
 * -----------------------------------------------------------------------------
 * Help sub menu component.
 *
 * @param {Object} content - Content to be displayed.
 */
import ClickableList from '~global/clickable-list/clickable-list'

import { formatLinklist } from '~/helpers/format'

export default {
  name: 'SubMenuHelp',

  components: {
    ClickableList,
  },

  props: {
    content: {
      type: Object,
      default: () => ({}),
    },
  },

  computed: {

    /**
     * Returns a formatted list of linklist items for use in clickable-list
     * component.
     * @returns {Array}
     */
    clickableListContent() {
      return this.content?.help?.links?.items?.map(linklist => formatLinklist(linklist))
    },
  },

  methods: {

    /**
     * Resets the linklist in the component on mouseleave.
     */
    resetList() {
      const links = this.$refs.helpLinks

      if (!links) {
        return
      }

      links.resetComponentData()
    },
  },
}
</script>
